export const cepInputValidator = (
  e: React.ChangeEvent<HTMLInputElement>
): string => {
  let value = e.target.value;
  value = value.replace(/\D/g, ''); // remove o que não é número
  e.currentTarget.maxLength = 9;
  value = value.replace(/(\d)(\d{3})$/, '$1-$2');
  return value;
};
